import { computed } from "vue";
import { defineStore, storeToRefs } from "pinia";
import { useSurveyStore } from "./survey";
import { useSurveyCardsStore } from "./surveyCards";
import { useSurveyLocalesStore } from "./surveyLocales";
import { capitalize, isEmpty } from "@utils/toolBox";

export const useSurveyErrorsStore = defineStore("surveyErrors", () => {
  const parentStore = useSurveyStore();
  const surveyCardsStore = useSurveyCardsStore();
  const { cards } = storeToRefs(surveyCardsStore);
  const surveyLocalesStore = useSurveyLocalesStore();

  // getters
  const errors = computed(() => parentStore.survey?.errors?.filter((error) => error.name !== "quotas") ?? []); // quotas errors are handled by quotas store
  const errorsByCard = computed(() => prepareErrors());
  const hasErrors = computed(() => !isEmpty(errors.value));

  // actions
  const cleanErrors = () => (parentStore.survey.errors = []);

  const prepareErrors = () => {
    const computedErrors = {};
    errors.value.forEach((error) => {
      // First we want to convert each error path to a card token and format error message
      if (error.path) {
        cards.value.forEach((card, i) => {
          if (i === parseInt(error.path.match(/cards\[(\d+)\]/)?.[1], 10)) {
            error.path = card.token;
          }
        });
        error.message = capitalize(surveyLocalesStore.labelizeLocale(error.message));

        // Then we want to create a list of errors for each card
        if (isEmpty(computedErrors[error.path])) computedErrors[error.path] = [error.message];
        else if (!isEmpty(computedErrors[error.path]) && !computedErrors[error.path].includes(error.message))
          computedErrors[error.path].push(error.message);
      }
    });
    return computedErrors;
  };

  return {
    // getters
    errors,
    errorsByCard,
    hasErrors,
    // actions
    cleanErrors,
  };
});
